import getFaceAndBodyCarouselAdjustedPosition from "./getFaceAndBodyCarouselAdjustedPosition";
import { Fragment } from "react";

const addFaceAndBodyCarousel = ({ faceAndBodyCarousel, items, adPosition }) => {
  if (!faceAndBodyCarousel) {
    return items;
  }

  const adjustedCarouselPosition = getFaceAndBodyCarouselAdjustedPosition(
    adPosition
  );

  return [
    ...items.slice(0, adjustedCarouselPosition),
    <Fragment key="faceAndBodyCarousel">{faceAndBodyCarousel}</Fragment>,
    ...items.slice(adjustedCarouselPosition)
  ];
};

export default addFaceAndBodyCarousel;
